export default Object.freeze({
    LoginHeaders: {
        // NOTE: Axios headers are lowercase
        userSwitched: 'x-platform-user-switched',
    },
})
